import {
  SET_SIGN_IN_LOADING,
  SET_SIGN_IN_SUCCESS,
  SET_SIGN_IN_ERROR,
  SET_SIGN_UP_LOADING,
  SET_SIGN_UP_SUCCESS,
  SET_SIGN_UP_ERROR,
  SET_SIGN_OUT,
  SET_POST_BIO_LOADING,
  SET_POST_BIO_SUCCESS,
  SET_POST_BIO_ERROR,
  SET_SIGN_UP_SUCCESS_LOADING,
  SET_FTU_COMPLETE_LOADING,
  SET_FTU_COMPLETE_SUCCESS,
  SET_FTU_COMPLETE_ERROR
} from '../../Constants/action-types';

import { SIGN_IN, SET_BIO_INFO_URL, FTU_COMPLETE_URL } from '../../functionality/networking';

import posthog from 'posthog-js';

import * as moment from 'moment';

function setSignUpLoading() {
  return {
    type: SET_SIGN_UP_LOADING
  };
}

function setSignUpSuccess() {
  return {
    type: SET_SIGN_UP_SUCCESS
  };
}

function setSignUpSuccessLoading(bool) {
  return {
    type: SET_SIGN_UP_SUCCESS_LOADING,
    bool: bool
  };
}

function setSignUpError(errorCode) {
  return {
    type: SET_SIGN_UP_ERROR,
    errorCode: errorCode
  };
}

function setSignInLoading() {
  return {
    type: SET_SIGN_IN_LOADING
  };
}

function setSignInSuccess() {
  return {
    type: SET_SIGN_IN_SUCCESS
  };
}

function setSignInError() {
  return {
    type: SET_SIGN_IN_ERROR
  };
}

function setSignOut() {
  return {
    type: SET_SIGN_OUT
  };
}

function setPostBioLoading() {
  return {
    type: SET_POST_BIO_LOADING
  };
}

function setPostBioSuccess() {
  return {
    type: SET_POST_BIO_SUCCESS
  };
}

function setPostBioError() {
  return {
    type: SET_POST_BIO_ERROR
  };
}

function setFtuCompleteLoading() {
  return {
    type: SET_FTU_COMPLETE_LOADING
  };
}

function setFtuCompleteSuccess() {
  return {
    type: SET_FTU_COMPLETE_SUCCESS
  };
}

function setFtuCompleteError() {
  return {
    type: SET_FTU_COMPLETE_ERROR
  };
}

export function callSignUp(email, handleStartNow, setSuccessOrErrorMessage, successMessage) {
  return (dispatch) => {
    dispatch(setSignUpLoading());
    return fetch(SIGN_IN, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email
      })
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success && setSuccessOrErrorMessage && successMessage) {
          dispatch(setSignUpSuccessLoading(false));
          setSuccessOrErrorMessage(successMessage);
        } else if (response.success) {
          dispatch(setSignUpSuccess());

          const startTime = moment.utc(moment().format());
          const now = moment.utc(moment().format());
          // const now = moment.utc(JSON.parse(localStorage.getItem('userLoginData')).timeStamp);

          // var duration = now.diff(startTime);
          // var duration = moment.duration(now.diff(startTime));

          // var seconds = duration.asSeconds();
          // console.log('duration', seconds);
          // console.log('asSeconds', startTime);
          // console.log('asSeconds', now);
          // console.log('asSeconds', seconds);
          // console.log(
          //   'count',W
          //   JSON.parse(localStorage.getItem('userLoginData'))?.count
          // );
          // console.log(
          //   'diff',
          //   moment
          //     .duration(now.diff(JSON.parse(localStorage.getItem('userLoginData'))?.timeStamp))
          //     .asSeconds()
          // );
          if (localStorage.getItem('userLoginData') === null) {
            localStorage.setItem(
              'userLoginData',
              JSON.stringify({
                count: 1,
                timeStamp: startTime
              })
            );
          } else if (
            localStorage.getItem('userLoginData') !== null &&
            JSON.parse(localStorage.getItem('userLoginData'))?.count >= 1 &&
            moment
              .duration(now.diff(JSON.parse(localStorage.getItem('userLoginData'))?.timeStamp))
              .asSeconds() <= 86400
          ) {
            // show new error message here
            dispatch(setSignUpSuccessLoading(false));
            const didNotRecieveLinkFormattedSubject = 'Please send me my verification link';
            const didNotRecieveLinkFormattedBody =
              'Dear TMX - I wanted to let you know I didn’t get my link.';
            const didNotRecieveLinkMailToLink =
              'mailto:getsearchlink@usetmx.com?subject=' +
              encodeURIComponent(didNotRecieveLinkFormattedSubject) +
              '&body=' +
              encodeURIComponent(didNotRecieveLinkFormattedBody);

            setSuccessOrErrorMessage(
              <div className="tmx-messenger__errorMessage">
                It appears our email is blocked by your spam filter -{' '}
                <a className="tmx-messenger__errorMessage" href={didNotRecieveLinkMailToLink}>
                  click here to get link manually.
                </a>
              </div>
            );
            localStorage.setItem(
              'userLoginData',
              JSON.stringify({
                count: JSON.parse(localStorage.getItem('userLoginData'))?.count + 1,
                timeStamp: JSON.parse(localStorage.getItem('userLoginData'))?.timeStamp
              })
            );
          } else if (
            localStorage.getItem('userLoginData') !== null &&
            JSON.parse(localStorage.getItem('userLoginData'))?.count >= 1 &&
            moment
              .duration(now.diff(JSON.parse(localStorage.getItem('userLoginData'))?.timeStamp))
              .asSeconds() > 86400
          ) {
            // reset local storage variable here
            localStorage.setItem(
              'userLoginData',
              JSON.stringify({
                count: 1,
                timeStamp: startTime
              })
            );
          }
        } else if (response.error === '401 Unauthorized: Not Verified Plus: NOT_IN_SYSTEM') {
          // user not in database
          // dispatch(setSignUpError('401 Unauthorized: Not Verified Plus: UNVERIFIED'));
          dispatch(setSignUpError(''));
          handleStartNow(); // Swith here to signup flow here
        } else if (
          response.error === '401 Unauthorized: Not Verified Plus: VERIFIED' ||
          response.error === '401 Unauthorized: Not Verified Plus: UNVERIFIED'
        ) {
          // user in database but no permission
          dispatch(setSignUpError('401 Unauthorized: Not Verified Plus: VERIFIED'));
        }
      })
      .catch(() => {
        // dispatch(setSignUpError(error));
      });
  };
}

export function callSignIn(email, token) {
  return (dispatch) => {
    dispatch(setSignInLoading());
    return fetch(SIGN_IN, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
        token: token
      })
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          posthog.identify(email);
          dispatch(setSignInSuccess());
          localStorage.setItem(
            'userData',
            JSON.stringify({
              email: email,
              token: token,
              isAdmin: response.is_admin,
              // isAdmin: true,
              isNewsroom: response.is_newsroom,
              isFtuComplete: response.ftu_complete
              // isFtuComplete: false
            })
          );
        } else if (response.error === '401 Unauthorized: Expired token') {
          window.localStorage.clear();
          dispatch(callSignOut());
          window.location.replace('/');
        }
      })
      .catch((error) => {
        dispatch(setSignInError(error));
      });
  };
}

export function callFtuComplete(email, token) {
  return (dispatch) => {
    dispatch(setFtuCompleteLoading());
    return fetch(FTU_COMPLETE_URL, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
        token: token,
        ftu_complete: true
      })
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          posthog.identify(email);
          posthog.capture('FTU complete', {
            email: email
          });
          dispatch(setFtuCompleteSuccess());
          localStorage.setItem(
            'userData',
            JSON.stringify({
              email: email,
              token: token,
              isAdmin: response.is_admin,
              // isAdmin: true,
              isNewsroom: response.is_newsroom,
              isFtuComplete: response.ftu_complete
              // isFtuComplete: false
            })
          );
        }
      })
      .catch((error) => {
        dispatch(setFtuCompleteError(error));
      });
  };
}

export function callSignOut(email, token) {
  return (dispatch) => {
    dispatch(setSignOut());
  };
}

export function postBio(
  email,
  userBio,
  isDomainIdPresent,
  isNewsroom,
  setIsLoading,
  firstName,
  LastName,
  verificationType,
  setSuccessOrErrorMessage,
  setCurrentStage,
  setEmail
) {
  return (dispatch) => {
    dispatch(setPostBioLoading());
    return fetch(SET_BIO_INFO_URL, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        email: email,
        bio: userBio,
        domain_id: isDomainIdPresent === 'null' ? null : isDomainIdPresent,
        type: 'COMPLETE',
        first_name: firstName,
        last_name: LastName
      })
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          const formattedSubject = 'Requesting permission to the use the Search Engine';
          const mailToLink =
            'mailto:matt@usetmx.com?subject=' + encodeURIComponent(formattedSubject);

          const didNotRecieveLinkFormattedSubject = "I didn't receive my link to access TMX Search";

          const didNotRecieveLinkMailToLink =
            'mailto:matt@usetmx.com?subject=' +
            encodeURIComponent(didNotRecieveLinkFormattedSubject);

          dispatch(setPostBioSuccess());
          setIsLoading(false);
          setEmail('');
          setCurrentStage('EMAIL');
          // const testVerificationType = 2;
          if (verificationType === 2) {
            const successMessage = (
              <div className="tmx-messenger__successMessage">
                Check your inbox <b>(or spam/junk)</b> for the link to access the TMX search engine.
                If you didn't receive the email, please{' '}
                <a className="tmx-messenger__successMessage" href={didNotRecieveLinkMailToLink}>
                  Click here.
                </a>
              </div>
            );
            posthog.capture('Signup complete', {
              verification_type: verificationType,
              first_name: firstName,
              last_name: LastName,
              domain_id: isDomainIdPresent === 'null' ? null : isDomainIdPresent,
              email: email
            });
            dispatch(callSignUp(email, null, setSuccessOrErrorMessage, successMessage));
            // setSuccessOrErrorMessage(
            //   <div className="tmx-messenger__successMessage">
            //     Check your inbox <b>(or spam/junk)</b> for the link to access the TMX search engine.
            //     If you didn't receive the email, please{' '}
            //     <a className="tmx-messenger__successMessage" href={didNotRecieveLinkMailToLink}>
            //       Click here.
            //     </a>
            //   </div>
            // );
          } else if (verificationType === 0 || verificationType === 1) {
            setSuccessOrErrorMessage(
              <div className="tmx-messenger__errorMessage">
                You have now been added to our system but still need further verification.{' '}
                <a className="tmx-messenger__errorMessage" href={mailToLink}>
                  Click here.
                </a>
              </div>
            );
            posthog.capture('Signup complete', {
              verification_type: verificationType,
              first_name: firstName,
              last_name: LastName,
              domain_id: isDomainIdPresent === 'null' ? null : isDomainIdPresent,
              email: email
            });
          }
        }
      })
      .catch((error) => {
        dispatch(setPostBioError(error));
      });
  };
}
